import { Container } from '@qga/roo-ui/components';

import { Layout } from '@/v2/components/layout/Layout';

const LoadingView = () => {
  return (
    <Layout
      importantInformation={[]}
      navigation={[]}
      informationMessage={null}
      warningMessage={null}
      marketingMessage={null}
    >
      <Container py="4">Loading...</Container>
    </Layout>
  );
};

export default LoadingView;
